module.exports = __webpack_public_path__ + "img/img_back_babypink.c62eecda.png";